export default __webpack_public_path__ + "static/media/signup.26986cc9.PNG";